<div fxLayout="row" fxLayoutGap.gt-md="15px">
  <mat-card *ngIf="this.selectedCompany?.id" #dragRoot fxFlex.gt-md="70%" fxFlex="100%">
    <mat-card-content>
      <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center">
        <h4>{{approvalView ? 'Approvals' : 'Uploads'}}</h4>
        <button mat-flat-button color="primary" (click)="toggleApprovalView()"
          *ngIf="selectedCompany.type === builderType">{{ 'View ' + (approvalView ? 'Uploads' :
          'Approvals')}}</button>
      </div>
      <mat-card class="m-b-10" [style.display]="'block'">
        <mat-card-header [style.padding]="'10px'">
          <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <h5 class="m-b-10" [style.margin]="'0 0'">Partnered {{approvalView ? 'Suppliers' : 'Builders'}}</h5>

          </div>
        </mat-card-header>
        <mat-card-content>
          <mat-chip-list fxLayout="row wrap" class="m-b-10" selectable>
            <mat-chip [selected]="!partner" (click)="onPartnerFilterSelected(undefined)" color="primary" selectable
              *ngIf="!approvalView">
              Default
            </mat-chip>

            <ng-container *ngFor="let company of partners | async">
              <mat-chip color="primary" [selected]="partner?.id === company?.id"
                (click)="onPartnerFilterSelected(company)" selectable>
                <span [matBadge]="partnerPendingFiles[company.id]" matBadgeColor="accent">{{ company.name }}</span>
              </mat-chip>
            </ng-container>
          </mat-chip-list>
        </mat-card-content>
      </mat-card>
      <ng-container *ngIf="!approvalView">
        <mat-accordion>
          <ng-container *ngTemplateOutlet="subjectRow; context: {
              subjectLabel: 'Your Company', 
              subjectId: selectedCompany.id,
              subjectType: FileVaultSubjectType.Company,
              lscope: files[selectedCompany.id]?.scope
              }"></ng-container>
          <mat-expansion-panel #rangesPanel>
            <mat-expansion-panel-header>
              <div class="header-content w-100" fxLayout="row" fxLayout.lt-sm="column">
                <span [fxFlex]="'1 1 ' + (partner ? '30' : '15')">
                  <span [style.fontWeight]="rangesPanel.expanded ? '600' : 'normal'">Your Ranges</span>&nbsp;
                  <span [style.opacity]="'0.6'">{{partner ? 'shared with '+ partner.name : ''}}</span>
                </span>
                <div fxHide.lt-sm fxLayout="row" fxLayoutGap="5px" fxFlex class="truncate-wrapper">
                  <ng-container *ngIf="!rangesPanel.expanded">
                    <ng-container *ngFor="let material of files | truncate:filteredRanges:scope; let indx = index">
                      <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
                      <h3 *ngIf="indx >= 19">...</h3>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </mat-expansion-panel-header>
            <div fxLayout="column">
              <mat-accordion>
                <ng-container *ngFor="let range of filteredRanges">
                  <ng-container *ngTemplateOutlet="subjectRow; context: {
                subjectLabel: range.name, 
                subjectId: range.id,
                subjectType: FileVaultSubjectType.Range,
                lscope: files[range.id]?.scope
                }"></ng-container>
                </ng-container>
              </mat-accordion>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel #productsPanel>
            <mat-expansion-panel-header>
              <div class="header-content w-100" fxLayout="row" fxLayout.lt-sm="column">
                <span [fxFlex]="'1 1 ' + (partner ? '30' : '15')">
                  <span [style.fontWeight]="productsPanel.expanded ? '600' : 'normal'">Your Products</span>&nbsp;
                  <span [style.opacity]="'0.6'">{{partner ? 'shared with '+ partner.name : ''}}</span>
                </span>
                <div fxHide.lt-sm fxLayout="row" fxLayoutGap="5px" fxFlex class="truncate-wrapper">
                  <ng-container *ngIf="!productsPanel.expanded">
                    <ng-container *ngFor="let material of files | truncate:products:scope; let indx = index">
                      <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
                      <h3 *ngIf="indx >= 19">...</h3>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </mat-expansion-panel-header>
            <div fxLayoutGap="10px" class="w-100">
              <mat-card fxFlex="70" class="contrast">
                <mat-card-content>
                  <mat-form-field class="accent">
                    <mat-label>Search {{ totalItems }} products</mat-label>
                    <input matInput [formControl]="productFilterGroup.controls.name" type="text" name="searchTerm"
                      placeholder="Search {{ totalItems }} products">
                    <button mat-button *ngIf="productFilterGroup.controls.name.value" matSuffix mat-icon-button
                      aria-label="Clear" (click)="productFilterGroup.controls.name.reset();">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>
              <mat-card fxFlex="30" class="contrast">
                <mat-card-content>
                  <form>
                    <mat-form-field>
                      <input matInput type="text" placeholder="Filter by Product Type" matInput
                        (keydown.enter)="onProductTypeSelected(typeFilterName.value)" [formControl]="typeFilterName"
                        [matAutocomplete]="productTypeAuto">
                      <button mat-button *ngIf="typeFilterName.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="productFilterGroup.controls.type.reset()">
                        <mat-icon>close</mat-icon>
                      </button>
                      <mat-autocomplete #productTypeAuto="matAutocomplete"
                        (optionSelected)="onProductTypeSelected($event?.option?.value)">
                        <mat-option *ngFor="let productType of filteredProductTypes | async" [value]="productType.name">
                          <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                            <div class="product-type-dropdown-indicator" [style.background-color]="productType?.color"
                              matTooltip="Product Type"></div>
                            <span [innerHtml]="productType.name | encodeHtml | highlight: typeFilterName.value"></span>
                          </div>
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </form>
                </mat-card-content>
              </mat-card>
            </div>

            <mat-accordion>
              <cdk-virtual-scroll-viewport class="viewport" itemSize="100" maxBufferPx="2000" minBufferPx="300">
                <ng-container *cdkVirtualFor="let product of products; index as indx; trackBy: trackProduct">
                  {{requestProductPage(indx)}}
                  <ng-container *ngIf="product">
                    <ng-container *ngTemplateOutlet="subjectRow; context: {
                subjectLabel: product.name, 
                subjectId: product.id,
                subjectType: FileVaultSubjectType.Product,
                lscope: files[product.id]?.scope
                }">
                    </ng-container>
                  </ng-container>
                </ng-container>
              </cdk-virtual-scroll-viewport>
            </mat-accordion>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-container>
      <ng-container *ngIf="approvalView">
        <ng-container *ngTemplateOutlet="approvalViewTemplate"></ng-container>
      </ng-container>
    </mat-card-content>
  </mat-card>
  <mat-card fxFlex.gt-md="30%" fxShow.gt-md="true" fxShow="false" class="mockup-container">
    <mat-card-content fxFlex fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="12px" class="h-100 w-100">
      <ng-container *ngTemplateOutlet="phonePreview"></ng-container>
      <div class="tile-completeness" *ngIf="previewProductObj as p">
        <div class="tc-title">
          <span>Tile content</span>
          <a [href]="getProductEditUrl(p.id)" target="_blank" rel="noopener" class="tc-link">Open product</a>
        </div>
        <div class="tc-row" [class.tc-missing]="!hasRender(p)">
          <mat-icon>{{ hasRender(p) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          <span class="tc-label">Render</span>
          <code class="tc-field">product.previewArtifactId</code>
        </div>
        <div class="tc-row" [class.tc-missing]="!p.name || !p.sku">
          <mat-icon>{{ (p.name && p.sku) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          <span class="tc-label">Name / SKU</span>
          <code class="tc-field">product.name · sku</code>
        </div>
        <div class="tc-row" [class.tc-missing]="!hasDescription(p)">
          <mat-icon>{{ hasDescription(p) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          <span class="tc-label">Description</span>
          <code class="tc-field">product.description</code>
        </div>
        <div class="tc-subhead">Tile assets · {{ partner ? partner.name : 'Default' }}</div>
        <div class="tc-row tc-slot" *ngFor="let slot of tileRoleSlots"
          [class.tc-missing]="roleState(p.id, slot.role) === 'missing'"
          [class.tc-pending]="roleState(p.id, slot.role) === 'pending'">
          <mat-icon>{{ roleState(p.id, slot.role) === 'live' ? 'check_circle'
            : (roleState(p.id, slot.role) === 'pending' ? 'hourglass_empty' : 'radio_button_unchecked') }}</mat-icon>
          <span class="tc-label">{{ slot.label }}</span>
          <span class="tc-state" *ngIf="roleStateLabel(p.id, slot.role)">{{ roleStateLabel(p.id, slot.role) }}</span>
          <button mat-stroked-button color="accent" class="tc-upload" (click)="roleInput.click()">
            {{ roleState(p.id, slot.role) === 'missing' ? 'Upload' : 'Replace' }}
            <input #roleInput class="upload-input" type="file"
              (change)="onUploadForRole($event.target?.files, p.id, slot.role)"
              onclick="value = null" [accept]="slot.accept.join(',')">
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #phonePreview>
  <div class="mockup-phone">
    <div class="mockup-phone-camera"></div>
    <div class="mockup-phone-display">
      <button *ngIf="previewStack?.length > 1 || showcasePreviewProductId" mat-button class="back-button"
        (click)="onPreviewBack()">BACK</button>
      <div #showcaseHost *ngIf="showcasePreviewProductId" class="showcase-host"></div>
      <div *ngIf="!marketingFilePreview && !showcasePreviewProductId">Select a row item on the left to preview a showcase</div>
      <ng-container *ngIf="!showcasePreviewProductId">
      <ng-container *ngFor="let preview of marketingFilePreview; let i = index">
        <ng-container *ngIf="i === activePreview">
          <img *ngIf="preview.localType === FileType.IMAGE" [src]="preview.uri" style="object-fit: contain" fxFlex>
          <video *ngIf="preview.localType === FileType.VIDEO" [src]="preview.uri" controls autoplay muted></video>
          <ng-container *ngIf="preview.mapData">
            <svg [attr.viewBox]="'0 0 '+ preview.mapData?.width + ' ' + preview.mapData?.height"
              xmlns="http://www.w3.org/2000/svg" class="zone-map">
              <ng-container *ngFor="let zone of preview.mapData?.interactions">
                <circle *ngIf="zone.shape === 'Circle'" [ngClass]="{'selected': zone.selected}"
                  (click)="onPreview(zone.target, true)" [attr.cx]="zone.x" [attr.cy]="zone.y" [attr.r]="zone.radius">
                </circle>
                <rect *ngIf="zone.shape === 'Rect'" [ngClass]="{'selected': zone.selected}"
                  (click)="onPreview(zone.target, true)" [attr.x]="zone.x" [attr.y]="zone.y" [attr.width]="zone.width"
                  [attr.height]="zone.height">
                </rect>
              </ng-container>
            </svg>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="marketingFilePreview?.length > 1">
        <button mat-icon-button class="phone-preview-nav left"
          (click)="activePreview = (activePreview - 1 + marketingFilePreview.length) % marketingFilePreview.length"><mat-icon>chevron_left</mat-icon></button>
        <button mat-icon-button class="phone-preview-nav right"
          (click)="activePreview = (activePreview + 1) % marketingFilePreview.length"><mat-icon>chevron_right</mat-icon></button>
        <div class="phone-preview-indicators" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
          <!-- indicator selectable dots -->
          <button mat-icon-button *ngFor="let preview of marketingFilePreview; let i = index"
            class="phone-preview-indicator" [ngClass]="{'active': i === activePreview}" (click)="activePreview = i">
          </button>
        </div>
      </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #approvalViewTemplate>
  <mat-card class="w-100 contrast">
    <mat-card-content fxLayout="column" class="h-100 w-100 drop-group" fxLayoutGap="5px" cdkDropListGroup>
      <mat-card fxFlex>
        <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
          <mat-card-title>Approved Files</mat-card-title>
        </mat-card-header>
        <mat-card-content class='drop-grid' cdkDropList cdkDropListOrientation="horizontal"
          [cdkDropListData]="(partnerFiles | async).approved" (cdkDropListDropped)="onApprovalDropped($event, true)">
          <div class="drag-item" cdkDrag *ngFor="let material of (partnerFiles | async).approved"
            (click)="onPreview(material)" [cdkDragData]="material" [cdkDragPreviewContainer]="dragRoot"
            (cdkDragStarted)="dragging = true" (cdkDragEnded)="dragging = false">
            <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card fxFlex>
        <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
          <mat-card-title>Pending Files</mat-card-title>
        </mat-card-header>
        <mat-card-content class='drop-grid' cdkDropList cdkDropListSortingDisabled cdkDropListOrientation="horizontal"
          [cdkDropListEnterPredicate]="cantDrop" [cdkDropListData]="(partnerFiles | async).pending">
          <div class="drag-item" cdkDrag *ngFor="let material of (partnerFiles | async).pending"
            (click)="onPreview(material)" [cdkDragData]="material" (cdkDragStarted)="dragging = true"
            (cdkDragEnded)="dragging = false">
            <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
            <ng-template cdkDragPreview>
              <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
            </ng-template>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card fxFlex>
        <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
          <mat-card-title>Rejected Files</mat-card-title>
        </mat-card-header>
        <mat-card-content class='drop-grid' cdkDropList cdkDropListSortingDisabled cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="onApprovalDropped($event, false)" [cdkDropListData]="(partnerFiles | async).rejected">
          <div class="drag-item" cdkDrag *ngFor="let material of (partnerFiles | async).rejected"
            (click)="onPreview(material)" [cdkDragData]="material" (cdkDragStarted)="dragging = true"
            (cdkDragEnded)="dragging = false">
            <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
            <ng-template cdkDragPreview>
              <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
            </ng-template>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
</ng-template>



<ng-template #subjectRow let-subjectLabel="subjectLabel" let-subjectId="subjectId" let-subjectType="subjectType"
  let-lscope="lscope">
  <mat-expansion-panel class="w-100" #expansionPanel="matExpansionPanel"
    [ngClass]="{'contrast': expansionPanel.expanded}" [disabled]="!files[subjectId]?.allFiles.length">
    <mat-expansion-panel-header>
      <div class="header-content" fxLayout="row" fxLayout.lt-sm="column">
        <span fxFlex="1 0 15" [matTooltip]="subjectLabel">
          {{subjectLabel}}
        </span>
        <div *ngIf="!files[subjectId]?.allFiles?.length" fxLayoutAlign="center center" fxFlex="1 1 85">
          <button mat-stroked-button type="submit" (click)="newReferenceInput.click()">
            Upload Marketing Material(s)
            <input #newReferenceInput class="upload-input" type="file" multiple
              (change)="onFileChosen($event.target?.files, subjectId, subjectType, expansionPanel)"
              onclick="value = null" [accept]="acceptedTypes.join(',')">
          </button>
        </div>
        <div class="gallery" [ngClass]="{'default':!lscope?.[scope]?.attached?.length}"
          *ngIf="(lscope?.[scope]?.attached?.length || lscope?.['null']?.attached?.length) && !expansionPanel.expanded"
          fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" fxLayoutPadding="5px" fxFlex="1 1 85"
          fxHide.lt-sm>
          <ng-container
            *ngFor="let material of (lscope?.[scope]?.attached?.length ? lscope?.[scope]?.attached : lscope?.['null']?.attached)">
            <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
          </ng-container>
          <div class="watermark" *ngIf="!lscope?.[scope]?.attached?.length">Using Default Attachments</div>
        </div>
        <button mat-icon-button *ngIf="files[subjectId]?.allFiles?.length || subjectType === FileVaultSubjectType.Product"
          (click)="onRowPreview($event, subjectId, subjectType)" matTooltip="Preview Showcase"><mat-icon
            color="accent">send_to_mobile</mat-icon></button>
        <a mat-icon-button *ngIf="subjectType === FileVaultSubjectType.Product" [href]="getProductEditUrl(subjectId)"
          target="_blank" rel="noopener" (click)="$event.stopPropagation()" matTooltip="Open product in new tab"><mat-icon
            color="accent">open_in_new</mat-icon></a>
      </div>
    </mat-expansion-panel-header>
    <div #dragZone fxLayout="column" class="h-100 w-100 drop-group" fxLayoutGap="5px" cdkDropListGroup
      (drop)="dropHandler($event, subjectId, subjectType, dragZone)"
      (dragleave)="dragZone.classList.remove('file-hover')" (dragover)="dragHandler($event, dragZone)">
      <div class="usage-hint" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon class="hint-icon">info_outline</mat-icon>
        <span>
          Drag files from <strong>Available Files</strong> to <strong>Attached Files</strong> to include them in this showcase, or drop new files
          anywhere in this panel to upload. To permanently remove a file, drag it to the
          <strong>Delete</strong> bin that appears on the right while you're dragging.
        </span>
      </div>
      <mat-card fxFlex="50%">
        <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
          <mat-card-title>Attached Files</mat-card-title>
          <button mat-flat-button color="primary" [disabled]="!lscope?.[scope].edited"
            (click)="onSaveAttachedMaterials(subjectId)"><mat-icon>save</mat-icon>Save</button>
        </mat-card-header>
        <mat-card-content class='drop-grid' cdkDropList cdkDropListOrientation="horizontal"
          [cdkDropListData]="lscope?.[scope]?.attached || []" [cdkDropListEnterPredicate]="canDrop"
          (cdkDropListDropped)="onMaterialDropped($event, subjectId)">
          <div class="drag-item" cdkDrag *ngFor="let material of lscope?.[scope]?.attached" [cdkDragData]="material"
            [cdkDragPreviewContainer]="dragRoot" (click)="onOpenEditor(material, subjectId, subjectType)"
            (cdkDragStarted)="dragging = true" (cdkDragEnded)="dragging = false">
            <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card fxFlex="50%" fxLayout="row">
        <div fxFlex>
          <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
            <mat-card-title>Available Files</mat-card-title>
            <button [ngClass]="{'hidden' : dragging}" color="accent" mat-stroked-button type="submit"
              (click)="newReferenceInput.click()">
              <mat-icon>add</mat-icon>Upload
              <input #newReferenceInput class="upload-input" type="file" multiple
                (change)="onFileChosen($event?.target?.files, subjectId, subjectType)" onclick="value = null"
                [accept]="acceptedTypes.join(',')">
            </button>
          </mat-card-header>
          <mat-card-content class='drop-grid' cdkDropList cdkDropListSortingDisabled cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="onMaterialDropped($event, subjectId)" [cdkDropListData]="lscope?.[scope]?.available">
            <div class="drag-item" cdkDrag *ngFor="let material of lscope?.[scope]?.available" [cdkDragData]="material"
              (click)="onOpenEditor(material, subjectId, subjectType)" (cdkDragStarted)="dragging = true"
              (cdkDragEnded)="dragging = false">
              <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
              <ng-template cdkDragPreview>
                <ng-container *ngTemplateOutlet="thumbnail; context: {material: material}"></ng-container>
              </ng-template>
            </div>
          </mat-card-content>
        </div>
        <div [ngClass]="{'dragging' : dragging}" mat-stroked-button cdkDropList
          class="drop-delete mat-button mat-stroked-button mat-warn" fxLayout="column" fxLayoutAlign="start center"
          (cdkDropListDropped)="onRemoveDrop($event, subjectId, expansionPanel)">
          <span><mat-icon>delete</mat-icon>Delete</span>
        </div>
      </mat-card>
    </div>
  </mat-expansion-panel>
</ng-template>

<ng-template #thumbnail let-material="material" let-skipcheck="skipcheck">
  <div class="marketing-file-thumbnail" [ngClass]="{'truncate-default': material.usingDefault === scope}">
    <img *ngIf="material.localType === FileType.IMAGE" #imgThumb (load)="checkImgDimensions(imgThumb, material)"
      [src]="material.uri" [style.borderImage]="material.border ?? ''" [matTooltip]="material.tooltip"
      matTooltipClass="marketing-file-tooltip">
    <ng-container *ngIf="material.localType === FileType.VIDEO">
      <img *ngIf="material.thumbnail" #imgThumb (load)="checkImgDimensions(imgThumb, material)"
        [matTooltip]="material.tooltip" matTooltipClass="marketing-file-tooltip" [src]="material.thumbnail.uri"
        [style.borderImage]="material.border ?? ''">
      <mat-icon class="video-icon" [style.pointerEvents]="'none'">ondemand_video</mat-icon>
    </ng-container>
    <mat-icon class="aspect-warning" *ngIf="material.badAspect && !skipcheck"
      matTooltip="image aspect ratio is not 1:2">warning</mat-icon>
    <mat-icon class="article-icon" *ngIf="material.localType === FileType.PDF" [matTooltip]="material.tooltip"
      matTooltipClass="marketing-file-tooltip" [style.borderImage]="material.border ?? ''">article</mat-icon>
    <div class="bigram" *ngIf="material.localType === FileType.PDF" [matTooltip]="material.fileName">{{material.bigram}}
    </div>
  </div>
</ng-template>